import axios, { AxiosError, AxiosRequestConfig } from "axios";
import { API_BASE_URL, buildApiPath } from "../config/api";
import { getStudentAuthHeaders } from "../utils/studentSession";

const AUTH_EXPIRED_EVENT = "portal:auth-expired";

export const apiClient = axios.create({
  baseURL: `${API_BASE_URL}/api`
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token") || "";
  const authHeaders = getStudentAuthHeaders(token);
  
  if (config.headers) {
    Object.entries(authHeaders).forEach(([key, value]) => {
      config.headers.set(key, value);
    });
  }
  
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401 && typeof window !== "undefined") {
      window.dispatchEvent(new CustomEvent(AUTH_EXPIRED_EVENT));
    }
    return Promise.reject(error);
  }
);

export const withApiPath = (endpoint: string) => buildApiPath(endpoint);

export const apiRequest = <T = any>(config: AxiosRequestConfig) => apiClient.request<T>(config);

export const onAuthExpired = (callback: () => void) => {
  window.addEventListener(AUTH_EXPIRED_EVENT, callback);
  return () => window.removeEventListener(AUTH_EXPIRED_EVENT, callback);
};
